import { call, put, takeLatest } from "redux-saga/effects";
import { axiosInstance } from "../../axios/axios";
import { toast } from 'react-toastify';
import {
  FETCH_REMOTE_WORK_ENVIRONMENT,
  FETCH_REMOTE_WORK_ENVIRONMENT_SUCCESS,
  FETCH_REMOTE_WORK_ENVIRONMENT_FAILURE,
  SAVE_REMOTE_WORK_ENVIRONMENT,
  SAVE_REMOTE_WORK_ENVIRONMENT_SUCCESS,
  SAVE_REMOTE_WORK_ENVIRONMENT_FAILURE,
  FETCH_TALENT_REMOTE_WORK_ENVIRONMENT,
  FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_SUCCESS,
  FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_FAILURE
} from "../action-types";

function* fetchRemoteWorkEnvironmentSaga(action) {
  try {
    const response = yield call(axiosInstance, {
      url: "/api/remote-work-environment",
      method: "GET",
      headers: { Authorization: "Bearer " + action.token }
    });
    yield put({
      type: FETCH_REMOTE_WORK_ENVIRONMENT_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    yield put({ type: FETCH_REMOTE_WORK_ENVIRONMENT_FAILURE, error });
    if (action.intl) {
      toast.error(action.intl.formatMessage({ id: "global_error_alert" }));
    }
  }
}

function* saveRemoteWorkEnvironmentSaga(action) {
  try {
    const response = yield call(axiosInstance, {
      url: "/api/remote-work-environment",
      method: "POST",
      headers: { Authorization: "Bearer " + action.token },
      data: action.answers
    });
    yield put({
      type: SAVE_REMOTE_WORK_ENVIRONMENT_SUCCESS,
      payload: response.data.data
    });
    if (action.intl) {
      toast.success(action.intl.formatMessage({ id: "remoteWorkEnvironmentSaved" }));
    }
  } catch (error) {
    yield put({ type: SAVE_REMOTE_WORK_ENVIRONMENT_FAILURE, error });
    if (action.intl) {
      toast.error(action.intl.formatMessage({ id: "global_error_alert" }));
    }
  }
}

function* fetchTalentRemoteWorkEnvironmentSaga(action) {
  try {
    const response = yield call(axiosInstance, {
      url: `/api/talents/${action.talentId}/remote-work-environment`,
      method: "GET",
      headers: { Authorization: "Bearer " + action.token }
    });
    yield put({
      type: FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    yield put({ type: FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_FAILURE, error });
    if (action.intl) {
      toast.error(action.intl.formatMessage({ id: "global_error_alert" }));
    }
  }
}

export default function* remoteWorkEnvironmentSaga() {
  yield takeLatest(FETCH_REMOTE_WORK_ENVIRONMENT, fetchRemoteWorkEnvironmentSaga);
  yield takeLatest(SAVE_REMOTE_WORK_ENVIRONMENT, saveRemoteWorkEnvironmentSaga);
  yield takeLatest(FETCH_TALENT_REMOTE_WORK_ENVIRONMENT, fetchTalentRemoteWorkEnvironmentSaga);
}
